import { VStack } from '@chakra-ui/react';
import { KeyboardEvent } from 'react';

import { Badge, Box, Typography } from 'shared';

import { MorpheusSuggestion } from 'features/chat/config/types/Message';

type ChatMessageMorpheusSuggestionsProps = {
  suggestions: MorpheusSuggestion[];
  onSuggestionSelect: (prompt: string) => void;
};

export const ChatMessageMorpheusSuggestions = ({
  suggestions,
  onSuggestionSelect,
}: ChatMessageMorpheusSuggestionsProps) => {
  const handleKeyDown = (event: KeyboardEvent, prompt: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSuggestionSelect(prompt);
    }
  };

  return (
    <VStack align="start" gap={1} p={2.5}>
      <Typography>Select related quick actions:</Typography>
      <VStack gap={1} alignItems="start">
        {suggestions.map((suggestion) => (
          <Box
            key={suggestion.suggestionId}
            as="button"
            onClick={() => onSuggestionSelect(suggestion.prompt)}
            onKeyDown={(e) => handleKeyDown(e, suggestion.prompt)}
            aria-label={`Select suggestion: ${suggestion.label}`}
            background="none"
            border="none"
            padding={0}
            cursor="pointer"
          >
            <Badge
              colorPalette="lightGray"
              size="lg"
              _hover={{
                bg: 'gray.300',
              }}
            >
              {suggestion.label}
            </Badge>
          </Box>
        ))}
      </VStack>
    </VStack>
  );
};
